import React from "react";
import ReactMultiCarousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Styled, { css } from "styled-components";

import { useTheme } from "../../context/ThemeProvider";

import {
  Highlight,
  TextSlideMover,
  TextSlideShow,
  Title,
} from "../../styles/atoms/Texts";
import { ITheme } from "../../interface";

import { screenSize, BlogsData } from "../../constant";
const { maxWidth } = screenSize;

const Container = Styled.div`
    margin: 0 -1.5vw;
    @media screen and (max-width: ${maxWidth.mediumPhoneV1}){
        width: 95vw;
        margin: 0;
        position: relative;
        transform: translateX(-50%);
        left: 50%;
    }
`;

const StyledReactMultiCarousel = Styled(ReactMultiCarousel)`
    margin: 3vh 0 0 0;
`;
const BlogWrapper = Styled.div<{ $props: { theme: ITheme } }>`
    display: inline-block;
    height: 90%;
    width: 90%;
    border-radius: 5px;

    &:hover {
        box-shadow: #008dda 0px 1px 0px, #008dda 0px 0px 8px;
        cursor: pointer;
    }

    ${({ $props }) => {
      const { theme } = $props;

      return css`
        border: ${theme.colors.primary} solid 1px;
      `;
    }}
`;

const BlogThumbnail = Styled.img`
    width: 100%;
    height: 120px;
    border-radius: 5px;
    user-drag: none;
    -webkit-user-drag: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
`;

const BlogSection = () => {
  const { theme, oppositeTheme } = useTheme();
  return (
    <Container>
      <Title $props={{ showMyExperience: true }}>
        My <Highlight $props={{ theme }}>Blogs</Highlight>
      </Title>
      <StyledReactMultiCarousel
        ssr
        partialVisbile
        itemClass="image-item"
        responsive={{
          desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 4,
          },
          tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 3,
          },
          mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 2,
          },
        }}
        arrows={false}
        draggable
        swipeable
        autoPlay={true}
        autoPlaySpeed={5000}
        customTransition={"all 0.5s ease-in-out"}
      >
        {BlogsData.map(({ title, link, thumbnail }, index) => {
          return (
            <BlogWrapper key={index} $props={{ theme: oppositeTheme }}>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={link}
                style={{
                  textDecoration: "none",
                  color: theme.colors.font,
                }}
              >
                <BlogThumbnail src={thumbnail} />
                <TextSlideShow>
                  <TextSlideMover>{title}</TextSlideMover>
                </TextSlideShow>
              </a>
            </BlogWrapper>
          );
        })}
      </StyledReactMultiCarousel>
    </Container>
  );
};

export default BlogSection;
